import Web3 from 'web3';
import getRpcUrl from '@/utils/getRpcUrl';

const RPC_URL = getRpcUrl();

export const simpleRpcProvider = new Web3(window.ethereum);

export default null;
